import './Preview.css'

function Preview({selected, artNum2Name, artNum2NameFabric, artNum2NameBackFabric, feetWheels, shopUrl}) {
    const imgPath = `${shopUrl}out/pictures/master/config/`
    if (selected && artNum2NameFabric && artNum2NameBackFabric) {
        if (!artNum2NameFabric[selected.fabricId]) {
            console.error(`Stoff ${selected.fabricId} für Bett nicht in der Liste der Stoffe gefunden.`)
        }
        if (!artNum2NameFabric[selected.backFabricId]) {
            console.error(`Stoff ${selected.backFabricId} für Rückenteil nicht in der Liste der Stoffe gefunden.`)
        }
    }
    return (
        <main>
            {window.b2b === true ?
                <a href="https://www.fbf-bedandmore.de/" className="logo"><img src="img/fbf-bedandmore.svg" /></a>
            :
                <a href="https://www.fbf-home.de/" className="logo"><img src="img/fbf-home.svg" /></a>
            }

            {(!selected || !artNum2NameFabric || (selected.backId && !artNum2NameBackFabric) ) ?
                <div className="previewPlaceholder" />
            :
                <div className="preview" style={{backgroundImage:
                    (selected.topperQuantity ? ("url(" + imgPath + ((selected.topperQuantity < selected.frameQuantity) ? 'td' : ('t' + selected.topperQuantity)) + ".png") + "), " : "") +
                    (selected.mattressQuantity ? ("url(" + imgPath + ((selected.mattressQuantity < selected.frameQuantity) ? 'md' : ('m' + selected.mattressQuantity)) + ".png") + "), " : "") +
                    (artNum2NameFabric[selected.fabricId] ? ("url(" + imgPath +  "b" + selected.frameQuantity + "_" + artNum2NameFabric[selected.fabricId] + ".png" + "),") : "") +
                    ((selected.backId && artNum2NameBackFabric[selected.backFabricId]) ? ("url(" + imgPath + ((selected.backQuantity < selected.frameQuantity) ? 'rd' : ('r' + selected.backQuantity)) + "_" + artNum2Name[selected.backId] + "_" + artNum2NameBackFabric[selected.backFabricId] + ".png") + "), " : "") +
                    "url(" + imgPath +  (feetWheels > 0 ? "f" : "ff") + selected.frameQuantity + "_" + artNum2Name[selected.feetParentId] + ".png" + ")"
                }}>{}
                </div>
            }
        </main>
    )
}

export default Preview
